import React from 'react';
import { ProductFamilyCarousel } from '../carousel/product_family_carousel';
import { RecommendedProductFamily } from '@omniafishing/core';
import { ProductFamilyCard } from '../product_family_card/product_family_card';
import { useListAttributionUuid } from '../../hooks/use_list_attribution_uuid';
import styles from './ice_landing_page.less';

const generateFamilyCard =
  (className: string, list_uuid: string) =>
  (recommendedFamily: RecommendedProductFamily, position: number) => {
    return (
      <div className={className} key={recommendedFamily.product_family.handle}>
        <ProductFamilyCard
          recommendedFamily={recommendedFamily}
          position={position}
          list_uuid={list_uuid}
        />
      </div>
    );
  };

interface CarouselData {
  heading?: string;
  title: string;
  productFamilies: RecommendedProductFamily[];
  carouselType: string;
}

export const ProductFamilyCarouselContainer = ({ carousel }: { carousel: CarouselData }) => {
  const { heading, title, productFamilies, carouselType } = carousel;
  const list_uuid = useListAttributionUuid();
  const carouselClass = carouselType === 'single' ? styles.card__2_6 : styles.card__2_3;

  return (
    <>
      {carousel.productFamilies.length > 0 && (
        <>
          {heading && (
            <h2 className={styles.sectionHeading}>
              {heading}({productFamilies.length})
            </h2>
          )}
          <h3 className={styles.categoryHeading}>{title}</h3>
          <div className={styles.carousel}>
            <ProductFamilyCarousel
              products_families={productFamilies.map((rf) => rf.product_family)}
              arrows={true}
              list_id_title={title}
              list_uuid={list_uuid}
            >
              {productFamilies.map(generateFamilyCard(carouselClass, list_uuid))}
            </ProductFamilyCarousel>
          </div>
        </>
      )}
    </>
  );
};
